import React from 'react'
import useTranslation from 'next-translate/useTranslation'
import { CategoriesList } from 'SRC/modules/categories/components'

const categoryListPlaceholder = 'upišite ovdje šta prodajete... npr. automobil'

export const ChoiceCategoryPage = () => {
  const { t } = useTranslation('common')

  return <CategoriesList placeholder={t('addAdCategoryListPlaceholder')} baseHref='/addAd' baseAs='/dodaj/' />
}
